import { ApiService } from '@/services/api.services';
import { AnimatePresence, motion } from 'framer-motion';
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';

export default function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);

  // cek cookie di browser
  useEffect(() => {
    const consentCookie = Cookies.get('cookieConsent');
    if (!consentCookie) {
      setShowBanner(true);
    }
  }, []);

  // multi-tab support
  useEffect(() => {
    const listener = () => setShowBanner(false);
    window.addEventListener('cookieAccepted', listener);
    return () => window.removeEventListener('cookieAccepted', listener);
  }, []);

  const handleConsent = async (type) => {
    try {
      // simpan cookie secure
      Cookies.set('cookieConsent', type, {
        expires: 30,
        secure: true,
        sameSite: 'Strict',
      });

      setShowBanner(false);

      if (type === 'accepted') {
        window.dispatchEvent(new Event('cookieAccepted'));
      }

      // optional: kirim ke backend untuk analytics/statistik
      try {
        await ApiService.postCookieConsent({
          consent: type,
          details:
            type === 'accepted'
              ? { analytics: true, marketing: true }
              : { analytics: true, marketing: false },
        });
      } catch (err) {
        console.error('Error sending consent to backend:', err);
      }
    } catch (err) {
      console.error('Error setting cookie:', err);
    }
  };

  if (!showBanner) return null;

  return (
    <AnimatePresence>
      <motion.div
        role="dialog"
        aria-label="Cookie consent banner"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 50 }}
        transition={{ duration: 0.5 }}
        className="
          fixed bottom-0
          bg-primary-900/60 backdrop-blur-md text-white
          py-4 px-5
          w-full
          z-[9999]
        "
      >
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 max-w-screen-2xl mx-auto">
          <p className="text-xs md:text-sm flex-1">
            Kami menggunakan cookie untuk meningkatkan pengalaman Anda. Pilih{' '}
            <strong>Terima</strong> untuk menyetujui semua cookie atau <strong>Tolak</strong> untuk
            menolak cookie non-essential.
          </p>

          <div className="flex gap-3 mt-3 md:mt-0">
            <button
              onClick={() => handleConsent('declined')}
              className="bg-gray-700/70 hover:bg-gray-700/90 px-5 py-2 rounded-lg transition-colors text-xs md:text-sm"
            >
              Tolak
            </button>
            <button
              onClick={() => handleConsent('accepted')}
              className="bg-emerald-600/70 hover:bg-emerald-600/90 px-5 py-2 rounded-lg transition-colors text-xs md:text-sm"
            >
              Terima
            </button>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
